<shr-person [form]="userForm" [person]="user" [addressRequired]="false"></shr-person>